import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CargaMasivaPage",
    data() {
        let ss = new MainService();
        return {
            ss: ss,
            file: null,
            uploading: false,
            processing: false,
            previewRows: [],
            previewFields: [
                { key: "row", label: "#" },
                { key: "codigo_persona", label: "Código Persona" },
                { key: "codigo_origen", label: "Código Origen" },
                { key: "codigo_nuevo", label: "Código Nuevo" }
            ],
            batch: null,
            recentResults: [],
            resultFields: [
                { key: "row_index", label: "Fila" },
                { key: "persona_viatico_id", label: "ID Viático" },
                { key: "status", label: "Estado" },
                { key: "message", label: "Mensaje" }
            ],
            message: "",
            messageVariant: "info",
            reportReady: false,
            errorBag: {},
            auth: {}
        };
    },
    computed: {
        progressPercent() {
            if (!this.batch || !this.batch.totalRows) return 0;
            return Math.round((this.batch.processed / this.batch.totalRows) * 100);
        },
        hasFailed() {
            return this.batch && this.batch.failed && this.batch.failed > 0;
        }
    },
    methods: {
        showToast(text, variant = "info", title = "") {
            this.$bvToast.toast(text, { title: title || "Info", variant: variant, autoHideDelay: 5000 });
        },

        clearFile() {
            this.file = null;
            this.previewRows = [];
            this.batch = null;
            this.reportReady = false;
            this.errorBag = {};
        },

        handleFileChange(ev) {
            const f = ev.target.files ? ev.target.files[0] : null;
            this.file = f;
        },

        async onUploadFile() {
            if (!this.file) {
                this.showToast("Selecciona un archivo primero.", "warning", "Atención");
                return;
            }

            this.uploading = true;
            this.showToast("Subiendo archivo...", "info");

            try {
                const fd = new FormData();
                fd.append("file", this.file);

                // subir y arrancar el procesamiento automáticamente en el backend
                const res = await this.ss.uploadViaticos(fd);

                if (res.data && res.data.batch_id) {
                    this.batch = {
                        id: res.data.batch_id,
                        totalRows: res.data.totalRows || (res.data.preview ? res.data.preview.length : 0),
                        processed: 0,
                        success: 0,
                        failed: 0
                    };

                    this.previewRows = res.data.preview || [];

                    // si backend devolvió resumen final (síncrono)
                    if (res.data.status && res.data.status === "finished") {
                        this.batch.processed = res.data.processed || this.batch.processed;
                        this.batch.success = res.data.success || 0;
                        this.batch.failed = res.data.failed || 0;
                        this.recentResults = res.data.results_preview || [];
                        this.reportReady = true;
                        this.showToast(`Proceso finalizado. Éxitos: ${this.batch.success} - Fallos: ${this.batch.failed}`, this.batch.failed ? "warning" : "success");
                        this.uploading = false;
                        return;
                    }

                    // si backend ha aceptado y procesará en background o iniciará proceso,
                    // arrancamos polling para ver estado
                    this.showToast("Batch creado. Iniciando monitoreo...", "info");
                    this.pollBatchStatus(this.batch.id);
                } else {
                    this.showToast("Respuesta inesperada del servidor.", "danger");
                }
            } catch (err) {
                console.error(err);
                const msg = err.response?.data?.message || "Error subiendo el archivo.";
                this.showToast(msg, "danger");
            } finally {
                this.uploading = false;
            }
        },

        async pollBatchStatus(batchId) {
            // polling sencillo cada 2s
            this.processing = true;
            const poll = async () => {
                try {
                    const r = await this.ss.getBatch(batchId);
                    if (!r.data) {
                        // reintentar
                        setTimeout(poll, 2000);
                        return;
                    }

                    const data = r.data;
                    // adaptar nombres según tu controller (total_rows / processed etc.)
                    this.batch.totalRows = data.total_rows ?? this.batch.totalRows;
                    this.batch.processed = data.processed ?? this.batch.processed;
                    this.batch.success = data.success ?? this.batch.success;
                    this.batch.failed = data.failed ?? this.batch.failed;

                    this.recentResults = data.results_preview || this.recentResults;

                    if (data.status === "finished" || (this.batch.processed >= this.batch.totalRows && this.batch.totalRows > 0)) {
                        this.processing = false;
                        this.reportReady = true;
                        this.showToast(`Procesamiento terminado. Éxitos: ${this.batch.success} - Fallos: ${this.batch.failed}`, this.batch.failed ? "warning" : "success");
                        return;
                    }
                } catch (e) {
                    console.error(e);
                }
                setTimeout(poll, 2000);
            };

            poll();
        },

        async downloadReport() {
            if (!this.batch || !this.batch.id) return;
            try {
                const res = await this.ss.downloadBatchReport(this.batch.id, { responseType: "blob" });
                const blob = new Blob([res.data], { type: res.headers["content-type"] || "text/csv" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `viaticos_batch_${this.batch.id}.csv`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error(err);
                this.showToast("No se pudo descargar el reporte.", "danger");
            }
        },

        async reprocessFailed() {
            if (!this.batch || !this.batch.id) {
                this.showToast("No hay batch seleccionado.", "warning");
                return;
            }

            if (!this.hasFailed) {
                this.showToast("No hay registros fallidos para reprocesar.", "info");
                return;
            }

            try {
                const r = await this.ss.reprocessBatch(this.batch.id);
                if (r.data && r.data.batch_id) {
                    this.showToast("Reproceso iniciado.", "success");
                    // opcional: empezar a monitorear el nuevo batch
                    this.batch = { id: r.data.batch_id, totalRows: r.data.total || 0, processed: 0, success: 0, failed: 0 };
                    this.pollBatchStatus(this.batch.id);
                } else {
                    this.showToast("Respuesta inesperada al re-procesar.", "danger");
                }
            } catch (e) {
                console.error(e);
                this.showToast("Error al re-procesar fallidos.", "danger");
            }
        }
    },

    components: {
        dataTable,
        Loader
    },

    mounted() {
        this.auth = JSON.parse(localStorage.getItem("persona")) || {};
        if (!this.auth) this.$router.push("/Login");
    }
};
